export default [
  {
    path: '/faq',
    title: '所有FAQ',
    index: '0'
  },
  {
    path: '/faq',
    title: '常见问题',
    index: '1',
    children: [
      {
        path: '/faq',
        title: '操作问题',
        index: '1,0'
      },
      {
        path: '/faq',
        title: '访问报错',
        index: '1,1'
      },
      {
        path: '/faq',
        title: '错误码表',
        index: '1,2'
      },
      {
        path: '/faq',
        title: '概念问题',
        index: '1,3'
      }
    ],
  },
  {
    path: '/faq',
    title: '开放平台',
    index: '2',
    children: [
      {
        path: '/faq',
        title: '概念',
        index: '2,1'
      }
    ],
  },
];
